import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Mail, Send, Loader2, Eye } from "lucide-react";

export default function EmailPreviewCard() {
  const [html, setHtml] = useState("");
  const [busy, setBusy] = useState(false);
  const [sending, setSending] = useState(false);
  const [sender, setSender] = useState(null);

  useEffect(() => { api.get("/settings/email-expediteur").then((r) => setSender(r.data)).catch(() => {}); }, []);

  const load = async () => {
    setBusy(true);
    try { setHtml((await api.get("/settings/email-apercu", { responseType: "text" })).data); }
    catch { toast.error("Impossible de générer l'aperçu"); }
    finally { setBusy(false); }
  };
  const sendTest = async () => {
    setSending(true);
    try { toast.success((await api.post("/settings/email-test")).data.message); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
    finally { setSending(false); }
  };

  return (
    <div className="bg-white rounded-lg border border-dd-light p-6" data-testid="email-preview-card">
      <div className="flex items-start gap-4">
        <div className="w-11 h-11 rounded-lg bg-dd-blue/10 flex items-center justify-center shrink-0"><Mail className="text-dd-blue" size={22} /></div>
        <div className="flex-1 min-w-0">
          <h3 className="text-lg font-semibold text-dd-blue">Aperçu de l'e-mail de marque</h3>
          <p className="text-sm text-dd-warm mt-1">E-mail envoyé aux locataires et propriétaires (procès-verbal, avis des défauts, invitations) avec votre logo, vos couleurs et votre signature.</p>
          {sender && (
            <p className="text-xs mt-2" data-testid="email-sender-info">
              Adresse expéditrice : <span className="font-medium text-dd-night">{sender.adresse}</span>
              {sender.mode === "emergent" && <span className="text-dd-warm"> — pour envoyer depuis votre domaine, renseignez RESEND_API_KEY et SENDER_EMAIL dans la configuration du serveur.</span>}
            </p>
          )}
          <div className="flex flex-wrap gap-2 mt-4">
            <Button onClick={load} disabled={busy} className="h-11 bg-dd-blue hover:bg-dd-hover text-white" data-testid="email-preview-btn">
              {busy ? <Loader2 size={16} className="mr-1 animate-spin" /> : <Eye size={16} className="mr-1" />} {html ? "Actualiser l'aperçu" : "Afficher l'aperçu"}
            </Button>
            <Button variant="outline" onClick={sendTest} disabled={sending} className="h-11 border-dd-blue text-dd-blue" data-testid="email-test-btn">
              {sending ? <Loader2 size={16} className="mr-1 animate-spin" /> : <Send size={16} className="mr-1" />} M'envoyer un test
            </Button>
          </div>
          {html && <iframe title="Aperçu e-mail" srcDoc={html} sandbox="" className="mt-4 w-full h-[640px] rounded-md border border-dd-light bg-[#f4f3f0]" data-testid="email-preview-frame" />}
        </div>
      </div>
    </div>
  );
}
